module.exports = __webpack_public_path__ + "img/dcopslogo2.cd78ffb4.png";